import { render, staticRenderFns } from "./AddFileModalComponent.vue?vue&type=template&id=9b564608&"
import script from "./AddFileModalComponent.vue?vue&type=script&lang=js&"
export * from "./AddFileModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports